var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PublicKey } from "@solana/web3.js";
import { TOKEN_METADATA_PROGRAM, METAPLEX_AUTH_RULES } from "./const";
// import { Metaplex } from "@metaplex-foundation/js/dist/types/Metaplex";
import { Metaplex } from "@metaplex-foundation/js";
// const { Metaplex } = require("@metaplex-foundation/js");
export function findNftDataAndMetadataAccount(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var metaplex, nft, tokenStd, AccountData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    metaplex = new Metaplex(Data.connection);
                    return [4 /*yield*/, metaplex.nfts().findByMint({ mintAddress: Data.mint })];
                case 1:
                    nft = _a.sent();
                    tokenStd = nft.tokenStandard;
                    AccountData = PublicKey.findProgramAddressSync([Buffer.from("metadata"), TOKEN_METADATA_PROGRAM.toBuffer(), Data.mint.toBuffer()], TOKEN_METADATA_PROGRAM);
                    if (tokenStd) {
                        return [2 /*return*/, {
                                tokenStandard: tokenStd,
                                metadataAddress: nft.metadataAddress,
                                metadataBump: AccountData[1],
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                metadataAddress: nft.metadataAddress,
                                metadataBump: AccountData[1],
                            }];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    throw { blockchain: "solana", order: 0, status: "error", message: error_1 };
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function findNftMasterEdition(Data) {
    return PublicKey.findProgramAddressSync([
        Buffer.from("metadata"),
        TOKEN_METADATA_PROGRAM.toBuffer(),
        Data.mint.toBuffer(),
        Buffer.from("edition"),
    ], TOKEN_METADATA_PROGRAM)[0];
}
export function findUserTokenRecord(Data) {
    return PublicKey.findProgramAddressSync([
        Buffer.from("metadata"),
        TOKEN_METADATA_PROGRAM.toBuffer(),
        Data.mint.toBuffer(),
        Buffer.from("token_record"),
        Data.userMintAta.toBuffer(),
    ], TOKEN_METADATA_PROGRAM)[0];
}
export function findRuleSet(Data) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var metaplex, nft, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    metaplex = new Metaplex(Data.connection);
                    return [4 /*yield*/, metaplex.nfts().findByMint({ mintAddress: Data.mint })];
                case 1:
                    nft = _b.sent();
                    // console.log("nft", nft.programmableConfig.ruleSet);
                    if ((_a = nft.programmableConfig) === null || _a === void 0 ? void 0 : _a.ruleSet) {
                        return [2 /*return*/, nft.programmableConfig.ruleSet];
                    }
                    else {
                        return [2 /*return*/, METAPLEX_AUTH_RULES];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    throw { blockchain: "solana", order: 0, status: "error", message: error_2 };
                case 3: return [2 /*return*/];
            }
        });
    });
}
